/** Lightweight Core Web Vitals → GTM dataLayer. No gtag.js. */
export function installWebVitalsBeacon(): void {
  if (typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') {
    return;
  }

  const send = (name: string, value: number, rating?: string): void => {
    const w = window as unknown as { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: name,
      event_category: 'Web Vitals',
      value: Math.round(name === 'CLS' ? value * 1000 : value),
      event_label: rating || '',
      non_interaction: true,
    });
  };

  try {
    const lcpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const last = entries[entries.length - 1] as PerformanceEntry & { startTime: number };
      if (last) {
        send('LCP', last.startTime, last.startTime <= 2500 ? 'good' : last.startTime <= 4000 ? 'needs-improvement' : 'poor');
      }
    });
    lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch {
    /* unsupported */
  }

  try {
    let cls = 0;
    const clsObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries() as Array<PerformanceEntry & { hadRecentInput?: boolean; value?: number }>) {
        if (!entry.hadRecentInput) {
          cls += entry.value || 0;
        }
      }
      send('CLS', cls, cls <= 0.1 ? 'good' : cls <= 0.25 ? 'needs-improvement' : 'poor');
    });
    clsObserver.observe({ type: 'layout-shift', buffered: true });
  } catch {
    /* unsupported */
  }

  try {
    const inpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const last = entries[entries.length - 1] as PerformanceEntry & { duration: number };
      if (last) {
        send('INP', last.duration, last.duration <= 200 ? 'good' : last.duration <= 500 ? 'needs-improvement' : 'poor');
      }
    });
    inpObserver.observe({ type: 'event', buffered: true, durationThreshold: 16 } as PerformanceObserverInit);
  } catch {
    /* unsupported */
  }
}
